import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useLanguage } from '../../../i18n/LanguageContext';
import './tools.css';

const ToolShell = ({ title, subtitle, icon, actions, children }) => {
  const { t } = useLanguage();
  const text = t.toolsPage;

  return (
    <div className="quizify-tools-page">
      <div className="quizify-tools-header">
        <div className="quizify-tools-heading">
          <Button as={Link} to="/tools" variant="soft-primary" size="sm" className="quizify-tool-back-btn">
            <FiArrowLeft aria-hidden="true" />
            <span>{text.backToTools}</span>
          </Button>
          <div className="quizify-tools-title-row">
            {icon && <span className="quizify-tools-title-icon">{icon}</span>}
            <div>
              <h1>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
          </div>
        </div>
        {actions && <div className="quizify-tools-header-actions">{actions}</div>}
      </div>
      {children}
    </div>
  );
};

export default ToolShell;
